export const requestIsFulfilled = (response) => (response.meta.requestStatus = 'fulfilled');
